document.addEventListener('DOMContentLoaded', function() {
  var colorFilter = $('.h5--accent.strong.sidebar__heading:contains("Color")')[0];
  var activeColor = colorFilter && colorFilter.nextElementSibling && colorFilter.nextElementSibling.querySelector('.sidebar__item--active a');
  if (!activeColor) return;
  var selectedColor = activeColor.textContent.trim();
  var allSwatches = document.querySelectorAll('.grid__swatch__hover .swatch__button [data-swatch=' + selectedColor + ']');
  console.log(allSwatches);
  allSwatches.forEach((swatch) => {
    swatch.click();
    const mouseoverEvent = new Event('mouseenter');
    swatch.dispatchEvent(mouseoverEvent);
  })
});

